import { configureStore } from "@reduxjs/toolkit";
import jobPostSlice from './postslice'
export const store=configureStore({
    reducer:{
jobPostSlice
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false, // Disable non-serializable value checking
        immutableCheck: false, // Disable immutable state checking
      })
})